import CONSTANTS from "../../constants";
import fetchWithAuthorizationHeader from "../../helper/fetchWithAuthorizationHeader";
import { GcpCertApprovalRequest } from "../../types/gcpCert";

const { GCPCERTS_API_URL } = CONSTANTS

const approveCert = async(resourceApproval: GcpCertApprovalRequest): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      action: 'APPROVE'
    },
    body: JSON.stringify(resourceApproval)
  })

  return response.json()
}

export default approveCert